import React, { useState, useEffect } from 'react';
import Box, { BoxProps } from '@mui/material/Box';
import Container from '@mui/material/Container';

export default function BottomFix({ children, enableHeight = true, ...props }: { enableHeight?: boolean } & BoxProps) {
  const ref = React.useRef<HTMLDivElement>(null);
  const [spacerHeight, setSpacerHeight] = useState(0); // 상단 박스의 높이를 저장하는 상태

  useEffect(() => {
    if (ref.current) {
      setSpacerHeight(ref.current.offsetHeight); // 하단 박스의 높이를 가져와 상태를 업데이트
    }
  }, [children]); // children이 변경될 때마다 높이를 다시 계산 (필요에 따라 다른 의존성 배열을 설정할 수 있음)

  return (
    <>
      {enableHeight && <Box height={`${spacerHeight}px`} />}
      <Box ref={ref} position="fixed" bottom={0} zIndex={100} bgcolor="white" width="100%" left={0}>
        <Container>{children}</Container>
      </Box>
    </>
  );
}
